import moment from 'moment';
import Swal from 'sweetalert2';
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'ProductsManage',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        await Promise.all([
            this.loadApprovedNationalFormulary(),
            this.GetAllManufacturers(),
            this.GetAllCountries(),
        ]);

        if (this.loginDetails && this.loginDetails.userType != 1) {
            this.logout();
        }

        this.GetInfo();
    },

    mounted() {
        const el = document.getElementById('offcanvasProductForm');
        if (el) {
            el.addEventListener('hidden.bs.offcanvas', this.onDrawerHidden);
        }
    },

    beforeDestroy() {
        if (this.formularySearchTimer) {
            clearTimeout(this.formularySearchTimer);
        }
        const el = document.getElementById('offcanvasProductForm');
        if (el) {
            el.removeEventListener('hidden.bs.offcanvas', this.onDrawerHidden);
        }
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
        statsCards() {
            return [
                this.statCard('إجمالي المنتجات', this.Statistics && this.Statistics.count, 'primary', 'ti ti-package'),
                this.statCard('قيمة المخزون', `${this.formatNumber(this.Statistics && this.Statistics.price)} د.ل`, 'success', 'ti ti-currency-dollar'),
                this.statCard('قرب انتهاء الصلاحية', this.Statistics && this.Statistics.productExpiryCount, 'danger', 'ti ti-alert-triangle'),
                this.statCard('التصنيفات المستخدمة', this.Statistics && this.Statistics.categoriesCount, 'info', 'ti ti-category'),
            ];
        },
        drawerTitle() {
            return this.drawerMode === 'create'
                ? `إضافة ${this.ScreenTitleSingle}`
                : `تعديل ${this.ScreenTitleSingle}`;
        },
        drawerSubtitle() {
            return this.drawerMode === 'create'
                ? 'اربط المنتج بصنف نمطي معتمد، ثم أدخل الاسم التجاري وباقي البيانات.'
                : 'حدّث بيانات المنتج من اللوحة الجانبية مباشرة.';
        },
        drawerSubmitLabel() {
            return this.drawerMode === 'create' ? `إضافة ${this.ScreenTitleSingle}` : 'حفظ التعديلات';
        },
        currentStatusText() {
            if (this.drawerMode === 'create') return 'سيُفعّل مباشرة';
            return Number(this.SelectedItem && this.SelectedItem.status) === 1 ? 'مفعل' : 'موقوف';
        },
        currentStatusClass() {
            if (this.drawerMode === 'create') return 'bg-label-success';
            return Number(this.SelectedItem && this.SelectedItem.status) === 1 ? 'bg-label-success' : 'bg-label-warning';
        },
        selectedFormularyPreview() {
            const id = this.ruleForm.NationalFormularyItemsId;
            if (!id) return null;
            const n = Number(id);
            return (this.ApprovedFormularyItems || []).find(x => Number(x.id) === n)
                || (this.SelectedItem && Number(this.SelectedItem.nationalFormularyItemId || this.SelectedItem.nationalFormularyItemsId) === n ? {
                    id: n,
                    nationalCode: this.SelectedItem.nationalCode,
                    scientificName: this.SelectedItem.nationalFormularyName,
                    categoryName: this.SelectedItem.categories,
                } : null);
        },
    },

    filters: {
        moment(date) {
            if (!date) return '---';
            return moment(date).format('DD/MM/YYYY');
        },
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: 'المنتجات',
            ScreenTitleSingle: 'منتج',
            ScreenTitleSingleAl: 'المنتج',

            Info: [],
            Statistics: {},
            Countries: [],
            Manufacturers: [],
            ApprovedFormularyItems: [],
            formularyRemoteLoading: false,
            formularySearchTimer: null,

            SelectedItem: null,
            drawerMode: 'create',

            ruleForm: {
                Id: '',
                NationalFormularyItemsId: '',
                ProductName: '',
                ManufacturerId: '',
                CountryRegionId: '',
                BatchNumber: '',
                Descriptions: '',
                Image: '',
                ImageName: '',
                ShowOnPublicFormulary: true,
            },
            rules: {
                ProductName: this.$helper.Required(),
                NationalFormularyItemsId: this.$helper.Required(),
            },
        };
    },

    methods: {

        // ─── helpers ───────────────────────────────────────────────────────────
        moment(date) {
            if (!date) return '---';
            return moment(date).format('DD/MM/YYYY');
        },

        tableRowNumber(index) {
            return ((Number(this.pageNo) - 1) * Number(this.pageSize)) + index + 1;
        },

        productAvatarText(item) {
            const name = item && (item.productName || item.name) ? String(item.productName || item.name).trim() : '';
            if (!name) return 'PR';
            const parts = name.split(/\s+/).filter(Boolean);
            if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
            return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
        },

        resetFormState() {
            this.ruleForm = {
                Id: '',
                NationalFormularyItemsId: '',
                ProductName: '',
                ManufacturerId: '',
                CountryRegionId: '',
                BatchNumber: '',
                Descriptions: '',
                Image: '',
                ImageName: '',
                ShowOnPublicFormulary: true,
            };
        },

        clearValidationState() {
            if (this.$refs.ruleForm && this.$refs.ruleForm.clearValidate) {
                this.$refs.ruleForm.clearValidate();
            }
        },

        showDrawer() {
            const el = document.getElementById('offcanvasProductForm');
            if (el && window.bootstrap) {
                window.bootstrap.Offcanvas.getOrCreateInstance(el).show();
            }
        },

        hideDrawer() {
            const el = document.getElementById('offcanvasProductForm');
            if (el && window.bootstrap) {
                const drawer = window.bootstrap.Offcanvas.getInstance(el)
                    || window.bootstrap.Offcanvas.getOrCreateInstance(el);
                drawer.hide();
            }
        },

        onDrawerHidden() {
            this.clearValidationState();
        },

        async loadApprovedNationalFormulary(search = '') {
            this.formularyRemoteLoading = true;
            try {
                const res = await this.$http.GetNationalFormularyApproved(search, 500);
                this.ApprovedFormularyItems = this.normalizeNationalFormularyList(res.data);
            } catch {
                this.ApprovedFormularyItems = [];
            } finally {
                this.formularyRemoteLoading = false;
            }
        },

        normalizeNationalFormularyList(data) {
            const root = data || {};
            const raw = root.info != null ? root.info : root.Info;
            const arr = Array.isArray(raw) ? raw : [];
            return arr.map((r) => ({
                id: r.id != null ? r.id : r.Id,
                nationalCode: r.nationalCode != null ? r.nationalCode : (r.NationalCode || ''),
                scientificName: r.scientificName != null ? r.scientificName : (r.ScientificName || ''),
                categoryName: r.categoryName != null ? r.categoryName : (r.CategoryName || null),
            })).filter((x) => x.id != null);
        },

        remoteSearchNationalFormulary(query) {
            if (this.formularySearchTimer) {
                clearTimeout(this.formularySearchTimer);
            }
            const q = String(query || '').trim();
            this.formularySearchTimer = setTimeout(() => {
                this.loadApprovedNationalFormulary(q);
            }, 280);
        },

        ensureFormularyOptionForEdit(item) {
            const fid = item && (item.nationalFormularyItemId || item.nationalFormularyItemsId);
            if (!fid) return;
            const id = Number(fid);
            if (this.ApprovedFormularyItems.some(x => Number(x.id) === id)) return;
            this.ApprovedFormularyItems = [
                ...this.ApprovedFormularyItems,
                {
                    id,
                    nationalCode: item.nationalCode || '',
                    scientificName: item.nationalFormularyName || item.scientificName || '',
                    categoryName: item.categories || item.categoryName || null,
                },
            ];
        },

        formularySelectLabel(row) {
            if (!row) return '';
            const code = row.nationalCode || '';
            const sci = row.scientificName || '';
            return code ? `${sci} (${code})` : sci;
        },

        openCreateDrawer() {
            this.drawerMode = 'create';
            this.SelectedItem = null;
            this.resetFormState();
            this.$nextTick(() => this.clearValidationState());
        },

        openEditDrawer(item) {
            this.drawerMode = 'edit';
            this.SelectedItem = item;
            this.ensureFormularyOptionForEdit(item);
            this.ruleForm.Id = item.id;
            this.ruleForm.NationalFormularyItemsId = item.nationalFormularyItemId || item.nationalFormularyItemsId || '';
            this.ruleForm.ProductName = item.productName || item.name || '';
            this.ruleForm.ManufacturerId = item.manufacturerId != null && item.manufacturerId !== '' ? item.manufacturerId : '';
            this.ruleForm.CountryRegionId = item.countryRegionId != null && item.countryRegionId !== '' ? item.countryRegionId : '';
            this.ruleForm.BatchNumber = item.batchNumber || '';
            this.ruleForm.Descriptions = item.descriptions || '';
            this.ruleForm.ShowOnPublicFormulary = !!item.showOnPublicFormulary;
            this.ruleForm.Image = '';
            this.ruleForm.ImageName = '';
            this.$nextTick(() => {
                this.clearValidationState();
                this.showDrawer();
            });
        },

        showRequestError(title, err) {
            if (err.response && err.response.data) {
                this.$helper.ShowMessage('error', title, err.response.data);
            } else {
                this.$helper.ShowMessage('error', title, 'حدث خطأ غير متوقع');
            }
        },

        // ─── API ───────────────────────────────────────────────────────────────
        GetAllManufacturers() {
            return this.$http.GetAllManufacturers()
                .then(res => { this.Manufacturers = res.data.info || []; })
                .catch(() => { this.Manufacturers = []; });
        },

        async GetAllCountries() {
            try {
                const res = await this.$http.GetAllCountries();
                this.Countries = res.data.info || [];
            } catch {
                this.Countries = [];
            }
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || this.pageNo || 1;
            if (!this.Search) this.$blockUI.Start();
            this.$http.GetProducts(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = [];
                    this.Statistics = {};
                    this.pages = 0;
                });
        },

        SelectImage(file) {
            if (!file) return;
            if (!file.type.startsWith('image')) {
                this.$helper.ShowMessage('error', 'خطأ', 'الرجاء اختيار ملف صورة صالح');
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.ruleForm.ImageName = file.name;
                this.ruleForm.Image = reader.result;
            };
        },

        submitDrawerForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.drawerMode === 'create') {
                        this.createProduct();
                    } else {
                        this.updateProduct();
                    }
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        buildProductPayload() {
            return {
                Id: this.drawerMode === 'create' ? 0 : Number(this.ruleForm.Id),
                NationalFormularyItemsId: Number(this.ruleForm.NationalFormularyItemsId),
                ProductName: (this.ruleForm.ProductName || '').trim(),
                ManufacturerId: this.ruleForm.ManufacturerId === '' || this.ruleForm.ManufacturerId == null
                    ? null
                    : Number(this.ruleForm.ManufacturerId),
                CountryRegionId: this.ruleForm.CountryRegionId === '' || this.ruleForm.CountryRegionId == null
                    ? null
                    : Number(this.ruleForm.CountryRegionId),
                BatchNumber: this.ruleForm.BatchNumber || null,
                Descriptions: this.ruleForm.Descriptions || null,
                Image: this.ruleForm.Image || null,
                ImageName: this.ruleForm.ImageName || null,
                ShowOnPublicFormulary: !!this.ruleForm.ShowOnPublicFormulary,
            };
        },

        createProduct() {
            const payload = this.buildProductPayload();
            this.$blockUI.Start();
            this.$http.AddProducts(payload)
                .then(response => {
                    this.$blockUI.Stop();
                    this.hideDrawer();
                    this.GetInfo(1);
                    this.resetFormState();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch(err => {
                    this.$blockUI.Stop();
                    this.showRequestError('خطأ بعملية الإضافة', err);
                });
        },

        updateProduct() {
            const payload = this.buildProductPayload();
            this.$blockUI.Start();
            this.$http.EditProducts(payload)
                .then(response => {
                    this.$blockUI.Stop();
                    this.hideDrawer();
                    this.GetInfo(this.pageNo);
                    this.resetFormState();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch(err => {
                    this.$blockUI.Stop();
                    this.showRequestError('خطأ بعملية التعديل', err);
                });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من تغيير حالة المنتج؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد',
            }).then(result => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusProducts(Id)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch(err => {
                            this.$blockUI.Stop();
                            this.showRequestError('خطأ بعملية التعديل', err);
                        });
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد الحذف',
                text: 'هل أنت متأكد من حذف هذا المنتج؟',
                icon: 'warning',
                customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-label-secondary ms-2' },
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: 'حذف',
                cancelButtonText: 'إلغاء',
            }).then(result => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteProducts(Id)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch(err => {
                            this.$blockUI.Stop();
                            this.showRequestError('خطأ بعملية الحذف', err);
                        });
                }
            });
        },
    },
};
